import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const SortIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <g clipPath="url(#clip0_1890_4309)">
        <path d="M11.3213 9.71436H10.6517C10.6062 9.71436 10.5633 9.73668 10.5365 9.77328L7.9999 13.2697L5.4633 9.77328C5.43651 9.73668 5.39365 9.71436 5.34812 9.71436H4.67848C4.62044 9.71436 4.58651 9.78043 4.62044 9.82775L7.76865 14.1679C7.88294 14.3251 8.11687 14.3251 8.23026 14.1679L11.3785 9.82775C11.4133 9.78043 11.3794 9.71436 11.3213 9.71436V9.71436Z" />
        <path d="M11.3795 6.17239L8.23128 1.83221C8.11699 1.67507 7.88306 1.67507 7.76967 1.83221L4.62056 6.17239C4.61281 6.18307 4.60817 6.19568 4.60715 6.20883C4.60613 6.22198 4.60877 6.23516 4.61478 6.2469C4.62079 6.25864 4.62993 6.26849 4.6412 6.27535C4.65246 6.28222 4.66541 6.28583 4.6786 6.28578H5.34824C5.39377 6.28578 5.43663 6.26346 5.46342 6.22686L8.00002 2.73043L10.5366 6.22686C10.5634 6.26346 10.6063 6.28578 10.6518 6.28578H11.3215C11.3795 6.28578 11.4134 6.21971 11.3795 6.17239V6.17239Z" />
      </g>
    </IconWrapper>
  );
};

export default SortIcon;
